export type PricingTab = 'individual' | 'group';

export const PRICING_TAB_QUERY_KEY = 'tab';
export const DEFAULT_PRICING_TAB: PricingTab = 'individual';

export const getDefaultPricingTab = (countryCode: string): PricingTab =>
  countryCode === 'KR' ? DEFAULT_PRICING_TAB : 'group';

export function parsePricingTab(
  value: string | string[] | undefined,
  fallback = DEFAULT_PRICING_TAB,
): PricingTab {
  const tab = Array.isArray(value) ? value[0] : value;

  return tab === 'group' || tab === 'individual' ? tab : fallback;
}
